import React from 'react';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
}

/** Design-system checkbox (brand-tinted) with an optional inline label. */
export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, style, className = '', disabled, ...rest }, ref) => (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontFamily: 'var(--font-sans)',
        fontSize: 13.5,
        color: 'var(--text-secondary)',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <input
        ref={ref}
        type="checkbox"
        disabled={disabled}
        className={className}
        style={{ width: 16, height: 16, accentColor: 'var(--lime)', cursor: 'inherit', ...style }}
        {...rest}
      />
      {label}
    </label>
  ),
);
Checkbox.displayName = 'Checkbox';

export default Checkbox;
